<template lang="pug">
.onboarding-step
  .onboarding-step-congratulations
    .row.center
      .col.max
        h1 Congrats!
        p Now that you have the basics down, you can unlock the potential of your product and give your users a voice!
        .onboarding-step-animation
          LottieAnimation(svg="onboarding_4", :width="200", :height="200")
        button.button.primary-button(type="button", @click="done") Hooray, I did it!
</template>

<script>
  import LottieAnimation from '@/components/helpers/LottieAnimation'
  export default {
    name: 'OnboardingInvite',
    components: {
      LottieAnimation
    },
    beforeMount () {
    },
    data () {
      return {
      }
    },
    computed: {
    },
    methods: {
      done () {
        this.$emit('finished')
      }
    }
  }
</script>

<style lang="stylus" scoped>
.onboarding-step
  border $border-default
  .onboarding-step-congratulations
    padding 100px 80px 60px
    text-align center
    h1
      font-size 86px
      margin-bottom 40px
    p
      color $text-light
      margin-bottom 40px
    .onboarding-step-animation
      margin-bottom 40px
  +for_breakpoint(mobile)
    .onboarding-step-congratulations
      padding 40px 20px 30px
      h1
        font-size 42px
</style>
